module.exports = "/_next/static/resources/photo-1-303c2f44486cfaa966fb85cc706b0ce0.jpg";